<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        Purchase Order Wholesale Form
        <div class="card-header-actions">
          <button
            v-if="saveEnabled"
            class="btn btn-primary mr-1"
            @click="save()"
          >
            <i class="fa fa-save"></i> Save
          </button>
          <button class="btn btn-danger mr-1" @click="close()">
            <i class="fa fa-close"></i> Close
          </button>
        </div>
      </div>

      <b-form>
        <b-row>
          <b-col lg="8">
            <b-row>
              <b-col md="5">
                <b-input-group>
                  <b-input-group-prepend
                    ><label>Order Number</label></b-input-group-prepend
                  >
                  <b-form-input v-model="model.orderno" readonly></b-form-input>
                </b-input-group>
              </b-col>
              <b-col md="4">
                <b-input-group>
                  <b-input-group-append
                    ><span class="input-group-text"
                      >Order Date</span
                    ></b-input-group-append
                  >
                  <b-form-input
                    v-model="model.orderdate"
                    type="date"
                    @change="tanggalBerubah"
                    v-if="isEdit" readonly
                  ></b-form-input>
                  <b-form-input
                    v-model="model.orderdate"
                    type="date"
                    @change="tanggalBerubah"
                    v-else
                  ></b-form-input>
                </b-input-group>
              </b-col>
            </b-row>
            <b-input-group>
              <b-input-group-prepend
                ><label>Customer Group</label></b-input-group-prepend
              >
              <b-form-select
                v-model="model.customer_group"
                :plain="true"
                :options="custgroup"
                disabled
              ></b-form-select>
            </b-input-group>

            <b-input-group>
              <b-input-group-prepend
                ><label>Customer</label></b-input-group-prepend
              >
              <b-form-input
                readonly
                v-model="model.customer"
                :state="!$v.model.customer_id.$error"
              ></b-form-input>
              <b-input-group-append>
                <b-btn text="Button" @click="lkuCustomerShow = true" v-if="!isEdit">
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
            </b-input-group>

            <b-input-group>
              <b-input-group-prepend
                ><label>Supplier/Vendor</label></b-input-group-prepend
              >
              <b-form-input
                readonly
                v-model="model.vendorinfo"
                :state="!$v.model.vendor_id.$error"
              ></b-form-input>
              <b-input-group-append>
                <b-btn
                  text="Button"
                  @click="lkuVendorShow = true"
                  v-if="!isEdit"
                >
                  <i class="fa fa-search"></i>
                </b-btn>
              </b-input-group-append>
            </b-input-group>
            <b-form-row>
              <b-col md="4">
                <b-input-group>
                  <b-input-group-prepend
                    ><label>Currency </label></b-input-group-prepend
                  >
                  <b-input-group-prepend>
                    <b-form-select
                      v-model="model.matauang"
                      :plain="true"
                      :options="currency"
                      :disabled="sendToVendor == false"
                    ></b-form-select>
                  </b-input-group-prepend>
                </b-input-group>
              </b-col>
              <b-col md="8">
                <b-input-group>
                  <b-input-group-prepend
                    ><label style="width: 80px"
                      >Description</label
                    ></b-input-group-prepend
                  >
                  <b-form-input
                    v-model="model.remark"
                    placeholder="remark/description"
                    :readonly="sendToVendor == false"
                  ></b-form-input>
                </b-input-group>
              </b-col>
            </b-form-row>
          </b-col>
        </b-row>
        <b-card no-body class="mb-1">
          <b-table
            class="mb-0"
            ref="tblOrdLines"
            outlined
            striped
            hover
            small
            style="font-size: smaller"
            :items="ordLines.items"
            :fields="ordLines.fields"
            :current-page="ordLines.page"
            :per-page="ordLines.limit"
          >
            <template v-slot:cell(index)="data">
              {{ data.index + 1 }}
            </template>
            <template v-slot:cell(iteminfo)="data">
              {{ data.item.iteminfo ? `${data.item.iteminfo}` : "" }}
            </template>
            <template v-slot:cell(description)="data">
              <pre>{{ data.item.description }}</pre>
            </template>
            <template v-slot:cell(quantity)="data">
              {{ data.item.quantity | numFormat("0.[00]") }}
            </template>
            <template v-slot:cell(unitprice)="data">
              {{ data.item.unitprice | numFormat("0.,0") }}
            </template>
            <template v-slot:cell(nilai)="data">
              {{ data.item.nilai | numFormat("0.,0") }}
            </template>
            <template v-slot:cell(nilaidisc)="data">
              {{ data.item.nilaidisc | numFormat("0.,0") }}
            </template>
            <template v-slot:cell(nilainett)="data">
              {{ data.item.nilainett | numFormat("0.,0") }}
            </template>
            <template v-slot:cell(nilaippn)="data">
              {{ data.item.nilaippn | numFormat("0.,0") }}
            </template>
            <template v-slot:cell(nilaidue)="data">
              {{ data.item.nilaidue | numFormat("0.,0") }}
            </template>
            <template v-slot:cell(action)="data">
              <div class="text-center" v-if="sendToVendor">
                <a
                  href="javascript:void(0)"
                  class="text-danger"
                  @click="delOrdLines(data.index)"
                >
                  <i class="fa fa-trash"></i>
                </a>
              </div>
            </template>
            <template v-slot:row-details="row">
              <b-card class="row-details-form">
                <b-tabs card v-model="tabIndex">
                  <b-tab title="ITEM DETAIL" active>
                    <b-row h-align="center">
                      <b-col lg="6" xl="6" class="pl-0">
                        <b-input-group>
                          <b-input-group-prepend
                            ><label>Item</label></b-input-group-prepend
                          >
                          <b-form-input
                            v-model="ordLinesObj.itemname"
                            v-on:keyup.enter="findItems(ordLinesObj.itemname)"
                            :state="!$v.ordLinesObj.itemname.$error"
                          ></b-form-input>
                          <b-input-group-append>
                            <b-btn text="Button" @click="lkuItemShow = true">
                              <i class="fa fa-search"></i>
                            </b-btn>
                          </b-input-group-append>
                        </b-input-group>
                        <b-input-group>
                          <b-input-group-prepend
                            ><label>Description</label></b-input-group-prepend
                          >
                          <b-form-textarea
                            :rows="3"
                            :max-rows="13"
                            v-model="ordLinesObj.description"
                            v-on:focus="findItems(ordLinesObj.itemname)"
                            :state="!$v.ordLinesObj.description.$error"
                          ></b-form-textarea>
                        </b-input-group>
                        <b-form-row>
                          <b-col md="6">
                            <b-input-group>
                              <b-input-group-prepend
                                ><label
                                  >Category</label
                                ></b-input-group-prepend
                              >
                              <b-form-select v-model="ordLinesObj.itemcategory" :state="!$v.ordLinesObj.itemcategory.$error" :options="itemcategoryOpt" v-if="isnewproduct"></b-form-select>
                              <b-form-select v-model="ordLinesObj.itemcategory" :state="!$v.ordLinesObj.itemcategory.$error" :options="itemcategoryOpt" v-else disabled></b-form-select>
                            </b-input-group>
                          </b-col>
                          <b-col md="6">
                            <b-input-group>
                              <b-input-group-prepend
                                ><label
                                  >Sales Price</label
                                ></b-input-group-prepend
                              >
                              <b-input-group-prepend>
                                <span class="input-group-text">{{
                                  model.matauang
                                }}</span>
                              </b-input-group-prepend>
                              <my-number
                                class="form-control text-right"
                                v-model="ordLinesObj.saleprice"
                                :state="!$v.ordLinesObj.saleprice.$error"
                                :precision="2"
                              ></my-number>
                            </b-input-group>
                          </b-col>
                        </b-form-row>
                        <b-form-row>
                          <b-col md="6">
                            <b-input-group>
                              <b-input-group-prepend
                                ><label>Quantity</label></b-input-group-prepend
                              >
                              <b-form-input
                                v-model="ordLinesObj.quantity"
                                type="number"
                              ></b-form-input>
                            </b-input-group>
                          </b-col>
                          <b-col md="6">
                            <b-input-group>
                              <b-input-group-prepend
                                ><label style="width: 70px; text-align: right"
                                  >Unit Size</label
                                ></b-input-group-prepend
                              >
                              <b-form-input
                                v-model="ordLinesObj.unitsize" v-if="isnewproduct"
                              ></b-form-input>
                              <b-form-input
                                v-model="ordLinesObj.unitsize" v-else disabled
                              ></b-form-input>
                            </b-input-group>
                          </b-col>
                        </b-form-row>
                        <b-form-row>
                          <b-col md="8">
                            <b-input-group>
                              <b-input-group-prepend
                                ><label
                                  >Unit Price</label
                                ></b-input-group-prepend
                              >
                              <b-input-group-prepend>
                                <span class="input-group-text">{{
                                  model.matauang
                                }}</span>
                              </b-input-group-prepend>
                              <my-number
                                class="form-control text-right"
                                v-model="ordLinesObj.unitprice"
                                :precision="2"
                              ></my-number>
                            </b-input-group>
                          </b-col>
                          <b-col md="4">
                            <b-input-group>
                              <b-input-group-prepend
                                ><label style="width: 35px"
                                  >disc.</label
                                ></b-input-group-prepend
                              >
                              <!-- <b-form-input v-model="ordLinesObj.disc" @change="calcDiscValue()"></b-form-input> -->
                              <!-- <b-form-input v-model="ordLinesObj.disc" :precision="0"></b-form-input> -->
                              <my-number
                                v-model="ordLinesObj.disc"
                                :precision="0"
                              ></my-number>
                              <b-input-group-append
                                ><span class="input-group-text">
                                  %</span
                                ></b-input-group-append
                              >
                            </b-input-group>
                          </b-col>
                        </b-form-row>
                      </b-col>
                      <b-col lg="6" xl="5" class="pl-0">
                        <b-form-row>
                          <b-col xl="10">
                            <b-input-group>
                              <b-input-group-prepend
                                ><label>Amount</label></b-input-group-prepend
                              >
                              <b-input-group-prepend>
                                <span
                                  class="input-group-text"
                                  style="width: 60px"
                                  >{{ model.matauang }}</span
                                >
                              </b-input-group-prepend>
                              <my-number
                                class="form-control text-right"
                                v-model="ordLinesObj.nilai"
                                :precision="2"
                                disabled
                              ></my-number>
                            </b-input-group>
                            <b-input-group>
                              <b-input-group-prepend
                                ><label>Discount</label></b-input-group-prepend
                              >
                              <b-input-group-prepend>
                                <span
                                  class="input-group-text"
                                  style="width: 60px"
                                  >{{ model.matauang }}</span
                                >
                              </b-input-group-prepend>
                              <my-number
                                class="form-control text-right"
                                v-model="ordLinesObj.nilaidisc"
                                :precision="2"
                                @change.native="calcDiscPct()"
                                disabled
                              ></my-number>
                            </b-input-group>
                          </b-col>
                        </b-form-row>

                        <b-form-row>
                          <b-col xl="10">
                            <b-input-group>
                              <b-input-group-prepend
                                ><label
                                  >Net Amount</label
                                ></b-input-group-prepend
                              >
                              <b-input-group-prepend>
                                <span
                                  class="input-group-text"
                                  style="width: 60px"
                                  >{{ model.matauang }}</span
                                >
                              </b-input-group-prepend>
                              <my-number
                                class="form-control text-right"
                                v-model="ordLinesObj.nilainett"
                                :precision="2"
                                disabled
                              ></my-number>
                            </b-input-group>
                          </b-col>
                          <b-col xl="2">
                            <b-form-checkbox
                              id="chkPPN"
                              class="ml-1 mt-2 text-left"
                              v-model="ordLinesObj.kenappn"
                              value="1"
                              unchecked-value="0"
                              @change="calcTaxes(ordLinesObj)"
                              >PPN(VAT)</b-form-checkbox
                            >
                          </b-col>
                        </b-form-row>

                        <b-form-row v-if="ordLinesObj.kenappn == 1">
                          <b-col xl="6">
                            <b-input-group>
                              <b-input-group-prepend
                                ><label>Tarif DPP</label></b-input-group-prepend
                              >
                              <b-form-input
                                v-model="ordLinesObj.dppnlain"
                                @change="calcTaxes(ordLinesObj)"
                                disabled
                              ></b-form-input>
                              <b-input-group-append
                                ><span class="input-group-text"
                                  >%
                                </span></b-input-group-append
                              >
                              <b-input-group-append
                                ><span class="pt-2"
                                  ><strong> &nbsp; * Net Amount</strong>
                                </span></b-input-group-append
                              >
                            </b-input-group>
                          </b-col>
                          <b-col xl="4">
                            <b-input-group>
                              <b-input-group-prepend
                                ><span class="p-2"
                                  >Tarif PPN</span
                                ></b-input-group-prepend
                              >
                              <b-form-input
                                v-model="ordLinesObj.ppn"
                                @change="calcTaxes(ordLinesObj)"
                                type="number"
                                v-b-tooltip.hover
                                :title="ordLinesObj.ppn"
                              ></b-form-input>
                              <b-input-group-append
                                ><span class="input-group-text"
                                  >%</span
                                ></b-input-group-append
                              >
                            </b-input-group>
                          </b-col>
                        </b-form-row>
                        <b-form-row v-if="ordLinesObj.kenappn == 1">
                          <b-col xl="6">
                            <b-input-group>
                              <b-input-group-prepend
                                ><label
                                  >PPH akan dipotong</label
                                ></b-input-group-prepend
                              >
                              <b-form-select
                                v-model="ordLinesObj.pasalpph"
                                :plain="true"
                                :options="lookupPPH"
                                disabled
                              ></b-form-select>
                            </b-input-group>
                          </b-col>
                          <b-col xl="4">
                            <b-input-group>
                              <b-input-group-prepend
                                ><span class="p-2"
                                  >Tarif PPH</span
                                ></b-input-group-prepend
                              >
                              <b-form-input
                                v-model="ordLinesObj.pph"
                                type="number"
                                v-b-tooltip.hover
                                :title="ordLinesObj.pph"
                                disabled
                              ></b-form-input>
                              <b-input-group-append
                                ><span class="input-group-text"
                                  >%</span
                                ></b-input-group-append
                              >
                            </b-input-group>
                          </b-col>
                        </b-form-row>
                      </b-col>
                    </b-row>
                  </b-tab>
                </b-tabs>
                <b-row class="justify-content-center mt-1">
                  <div style="width: 400px">
                    <b-input-group>
                      <b-input-group-prepend
                        ><span class="p-2"
                          >Add Line after update</span
                        ></b-input-group-prepend
                      >
                      <b-form-checkbox
                        v-model="inputLineBerlanjut"
                        :value="1"
                        :unchecked-value="0"
                        class="pt-2"
                      ></b-form-checkbox>
                      <b-input-group-append>
                        <b-button
                          class="btn btn-success mr-1"
                          @click="saveOrdLines()"
                          >Update</b-button
                        >
                      </b-input-group-append>
                      <b-input-group-append>
                        <b-button
                          class="btn btn-warning ml-1"
                          @click="row.toggleDetails"
                          >Cancel</b-button
                        >
                      </b-input-group-append>
                    </b-input-group>
                  </div>
                </b-row>
              </b-card>
            </template>
          </b-table>
          <b-row>
            <b-col cols="5">
              <b-row>
                <b-button
                  size="sm"
                  class="ml-3"
                  @click.stop="addOrdLines"
                  v-if="sendToVendor"
                  >Add Item from Customer Request/Order</b-button
                >
                <div class="ml-2" style="padding-left: 10px">
                  Showing {{ (ordLines.page - 1) * ordLines.limit + 1 }} to
                  <span
                    v-if="ordLines.page * ordLines.limit > ordLines.total"
                    >{{ ordLines.total }}</span
                  >
                  <span v-else>{{ ordLines.page * ordLines.limit }}</span> of
                  {{ ordLines.total }} entries
                </div>
              </b-row>
            </b-col>
            <b-col cols="2">
              <b-input-group>
                <b-input-group-prepend
                  ><span class="ml-4 pt-1 mr-2"
                    >Limit per page</span
                  ></b-input-group-prepend
                >
                <b-form-select
                  :options="[5, 10, 15, 20, 25]"
                  :plain="true"
                  v-model="ordLines.limit"
                  style="width: 80px"
                />
              </b-input-group>
            </b-col>
            <b-col cols="5">
              <b-pagination
                align="right"
                :total-rows="ordLines.total"
                :per-page="ordLines.limit"
                v-model="ordLines.page"
              ></b-pagination>
            </b-col>
          </b-row>
        </b-card>
        <b-row align-h="between" class="mt-1">
          <b-col offset="8" lg="4">
            <div class="text-right">
              <b-input-group>
                <b-input-group-prepend
                  ><label
                    style="text-align: left; width: 158px; padding-left: 16px"
                    >Qty Total</label
                  ></b-input-group-prepend
                >
                <b-input-group-prepend>
                  <span class="input-group-text" style="width: 60px">{{
                    model.unitsize
                  }}</span>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.ttlqty"
                  disabled
                ></my-number>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend
                  ><label
                    style="text-align: left; width: 158px; padding-left: 16px"
                    >Subtotal</label
                  ></b-input-group-prepend
                >
                <b-input-group-prepend>
                  <span class="input-group-text" style="width: 60px">{{
                    model.matauang
                  }}</span>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.ttlnetto"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend>
                  <b-form-select
                    style="width: 158px"
                    v-model="calcVAT"
                    :plain="true"
                    :options="calcuationVAT"
                    :disabled="sendToVendor == false"
                  ></b-form-select>
                </b-input-group-prepend>
                <b-input-group-prepend>
                  <span class="input-group-text" style="width: 60px">{{
                    model.matauang
                  }}</span>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.nilaippn"
                  :precision="2"
                  :readonly="calcVAT === 1"
                ></my-number>
              </b-input-group>
              <b-input-group>
                <b-input-group-prepend
                  ><label
                    style="text-align: left; width: 158px; padding-left: 16px"
                    >Total Amount Due</label
                  ></b-input-group-prepend
                >
                <b-input-group-prepend>
                  <span class="input-group-text" style="width: 60px">{{
                    model.matauang
                  }}</span>
                </b-input-group-prepend>
                <my-number
                  class="form-control text-right"
                  v-model="model.ttlamtdue"
                  :precision="2"
                  disabled
                ></my-number>
              </b-input-group>
            </div>
          </b-col>
        </b-row>
      </b-form>

      <b-row class="justify-content-center mt-1">
        <div style="width: 300px">
          <b-input-group>
            <b-input-group-append>
              <button
                v-if="saveEnabled"
                class="btn btn-primary mr-1"
                @click="save()"
              >
                <i class="fa fa-save"></i> Save
              </button>
            </b-input-group-append>
            <b-input-group-append>
              <button class="btn btn-danger mr-1" @click="close()">
                <i class="fa fa-close"></i> Close
              </button>
            </b-input-group-append>
          </b-input-group>
        </div>
      </b-row>
    </b-card>
    <b-modal
      v-model="lkuVendorShow"
      size="lg"
      :hide-footer="true"
      title="List of Vendor"
      :centered="true"
    >
      <lku-supplier @click="onSelectLkuVendor"></lku-supplier>
    </b-modal>
    <b-modal
      v-model="lkuItemShow"
      size="lg"
      :hide-footer="true"
      title="List of Master Item"
      :centered="true"
    >
      <lku-item
        @click="onSelectLkuItem"
        @cliknewitem="addnewitem"
        isactive="1"
        autoadditem="1"
        :formdata="itemList"
        :customer_id="model.customer_id"
        :tgldelivery="model.orderdate"
      ></lku-item>
    </b-modal>

    <b-modal
      v-model="lkuCustomerShow"
      size="lg"
      :hide-footer="true"
      title="List of Customer Wholesale"
      :centered="true"
    >
      <lku-customer @click="onSelectLkuCustomer"></lku-customer>
    </b-modal>

    <loading
      :active.sync="isLoading"
      :height="128"
      :width="128"
      color="#4b8cf4"
    ></loading>
  </div>
</template>
<style lang="scss">
.input-group {
  padding-bottom: 2px;
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 130px;
    }
  }
}
.form-group {
  margin-bottom: 2px;
  .input-group {
    padding-bottom: 0;
  }
}
.row-details-form {
  .input-group-prepend {
    label {
      padding-top: 5px;
      padding-right: 5px;
      width: 80px;
    }
  }
  label {
    text-align: right !important;
  }
  legend {
    text-align: right !important;
  }
}
</style>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import toastr from "mini-toastr";
import moment from "moment";
import myNumber from "../../components/my-number";
import lkuSupplier from "../lookup/lkuSupplier";
import lkuItem from "../lookup/lkuItemLazzyCustPrice";
import procure from "../../apis/bakeryorder";
import customerprice from "../../apis/bakerycustomerprice";
import customer from "../../apis/bakerycustomer";
import { validationMixin } from "vuelidate";
import { required, numeric, decimal, minValue } from "vuelidate/lib/validators";
import dimension from "../../apis/dimension";
import lkuCustomer from "../lookup/lkuCustomerWholesale";
import crud from "../../apis/crud";

toastr.init();

export default {
  components: { Loading, myNumber, lkuSupplier, lkuItem, lkuCustomer },
  mixins: [validationMixin],
  validations: {
    model: {
      orderdate: { required },
      vendor_id: { required },
      matauang: { required },
      customer_id: { required },
    },
    ordLinesObj: {
      itemname: { required },
      description: { required },
      itemcategory: { required },
      quantity: { decimal, required },
      unitprice: { decimal, required },
      saleprice: { decimal, minValue: minValue(1) },
      nilai: { decimal, required },
      dppnlain: { numeric, required },
      disc: { decimal },
      kenappn: { required },
      ppn: { decimal },
      nilainett: { decimal },
    },
  },
  data() {
    return {
      saveEnabled: true,
      sendToVendor: true,
      isLoading: false,
      isEdit: false,
      inputBerlanjut: 0,
      inputLineBerlanjut: 1,
      lkuVendorShow: false,
      isnewproduct: true,
      itemList: {},
      tahun: (this.$store.state.user.tglaktif || "").substring(0, 4),
      uanguser: this.$store.state.user.matauang,
      currency: [{ value: "IDR", text: "IDR" }],
      calcVAT: 1,
      calcuationVAT: [
        { value: 1, text: "VAT (Auto Calc)" },
        { value: 0, text: "VAT (Manual Calc)" },
      ],
      calcPPh: 1,
      calcuationPPH: [
        { value: 1, text: "Nilai PPH(Otomatis)" },
        { value: 0, text: "Nilai PPH(Manual)" },
      ],
      lookupPPH: [],
      customers: [],
      items: [],
      itemprice: [],
      custprice: [],
      ordLines: {
        items: [],
      },
      itemcategoryOpt:[{value: null, text: 'Please select an option' }],
      footLines: [],
      custgroup: [{ value: "", text: "-- ALL--" }],
      lkuItemShow: false,
      lkuCustomerShow: false,
      updateDimDtl: true,
      linetypes: [
        { value: 1, text: "Master Item " },
        { value: 3, text: "GL Account" },
      ],
      ordLines: {
        items: [],
        selected: {},
        fields: [
          { key: "index", label: "No.", thStyle: "width:40px" },
          {
            key: "iteminfo",
            label: "Master Item",
          },
          {
            key: "description",
            label: "Description",
          },
          {
            key: "quantity",
            label: "Quantity",
            thStyle: "width:90px",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "unitprice",
            label: "Unit price",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "nilainett",
            label: "Amount NETTO",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "nilaippn",
            label: "Amount VAT",
            thStyle: "width:90px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "nilaidue",
            label: "Amount DUE",
            thStyle: "width:110px",
            thClass: "text-right",
            tdClass: "text-right",
          },
          {
            key: "pasalpph",
            label: "PPh",
            thStyle: "width:80px",
            thClass: "text-center",
            tdClass: "text-center",
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
          },
        ],
        page: 1,
        limit: 10,
        total: 0,
      },
      model: {
        jasa: 0,
        orderdate: moment().format("YYYY-MM-DD"),
        customer_id:'',
        vendor_id: "",
        vendor: "",
        requestno: "",
        ExpectRcv: "",
        remark: "",
        postgroup: "",
        typegroup: "OPEX",
        matauang: this.$store.state.user.matauang,
        compcode: this.$store.state.user.compcode,
        invterm: "COD",
        kodecash: "",
        terms: [],
        locationdeliv: this.$store.state.user.compaddr,
        ttlnetto: 0,
        ttlqty: 0,
        nilaippn: 0,
        ttlamtdue: 0,
        customer_group: "WHOLESALE",
        tanggal: "",
      },
      ordLinesObj: {
        linetype: 1,
        itemno: "",
        itemname: "",
        itemcategory:'',
        partnumber: "",
        description: "",
        quantity: 0,
        unitsize: "",
        unitprice: 0,
        saleprice: 0,
        nilai: 0,
        dppnlain: 100,
        disc: 0,
        kenappn: 0,
        ppn: 0,
        pasalpph: "",
        nilainett: 0,
      },
      tabIndex: 0,
    };
  },
  computed: {
    invalidModel() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    invalidOrdLines() {
      this.$v.ordLinesObj.$touch();
      return this.$v.ordLinesObj.$invalid;
    },
    dimension() {
      return this.$store.state.dimension;
    },
    noPPN() {
      return this.model.nilaippn == 0;
    },
    pasalpph() {
      return this.ordLinesObj.pasalpph;
    },
    disc() {
      return this.ordLinesObj.disc || 0;
    },
    quantity() {
      return this.ordLinesObj.quantity || 0;
    },
    unitprice() {
      return this.ordLinesObj.unitprice || 0;
    },
    nettprice() {
      return this.ordLinesObj.nettprice || 0;
    },
    // itemSuggest() {
    //     return "OKE";
    // },
  },

  watch: {
    // unitprice: function(newval) {
    //     setTimeout(() => {
    //         this.calcPrice();
    //     }, 100);
    // },
    // pasalpph: function(newval) {
    //     const item = this.lookupPPH ? this.lookupPPH.find(p => p.value==newval) : "";
    //     this.ordLinesObj.pph=item ? item.pph : "";
    //     setTimeout(() => {
    //         this.calcTaxes(this.ordLinesObj);
    //     }, 100);
    // },
    // noPPN: function(newval) {
    //     if (newval) {
    //         this.model.nofaktur='';
    //         this.model.tglfaktur='';
    //     }
    // },
    // itemSuggest: function() {
    //     console.log("#cekkk..");
    // },
    // "ordLinesObj.itemname": function (data) {
    //     console.log("#ini watch data: ", data);
    //   if (data == this.ordLinesObj.itemname) {
    //     setTimeout(() => {
    //       this.findItems(data);
    //     }, 500);
    //   }
    // }
  },

  created: async function () {
    
    this.itemcategoryOpt = (await crud.list({
      tablename:'itemcategory',
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'kode',
        sortDesc: true
    })).reduce((arr=[],obj,index)=>{
      arr.push({
         value: obj.nama, text: obj.nama
      });
      return arr;
    },[{value: '', text: 'Please select an option' }]); 
    if (this.$route.params.pohdrkey) {
      toastr.info("Loading Order Detail, please wait");
      try {
        this.isEdit = true;
        this.isLoading = true;
        const [a, b, data, custgroup, c, custdetail, custprice] = await Promise.all([
          procure.customeraktif(),
          procure.itemaktif(),
          procure.detail(this.$route.params),
          customer.group(),
          procure.pasalpph(),
          customer.detailwholesale(this.$route.params),
          customerprice.listcustprice(),
        ]);

        this.model.customer_group = "WHOLESALE";
        this.customers = a;
        this.items = b;
        this.lookupPPH = c;
        this.custprice = custprice;

        if(custdetail[0]){
            this.model.customer_id = custdetail[0].customer_id;
            this.model.customer = `${custdetail[0].CustName} | ${custdetail[0].CustCode}`;
        }

        if (custgroup) {
          custgroup.map((data) => {
            this.custgroup.push({
              value: data.value,
              text: data.text,
            });
          });
        }
        const row = data[0][0];
        row.orderdate = row.orderdate
          ? moment(row.orderdate).format("YYYY-MM-DD")
          : "";
        row.expectreceipt = row.expectreceipt
          ? moment(row.expectreceipt).format("YYYY-MM-DD")
          : "";
        for (var key in row) {
          this.model[key] = row[key];
        }
        if (
          row.orderdate < this.$store.state.user.tglaktif ||
          this.$route.params.status_sendtovendor
        ) {
          this.saveEnabled = false;
        }
        if (this.$route.params.status_sendtovendor) {
          this.sendToVendor = false;
        }
        this.ordLines.items = data[1];
        this.ordLines.total = this.ordLines.items.length;
        this.ordCustomer = data[2];
        this.model.ttlqty = 0;
        this.model.unitsize = "";
        this.ordLines.items.forEach((item) => {
          const custLines = this.ordCustomer.filter(
            (ip) => ip.podtlkey == item.podtlkey
          );
          if (custLines) {
            custLines.forEach((kol) => {
              item[`K${kol.CustCode}`] = kol.qtyOrder;
            });
          }

          this.model.ttlqty += item.quantity;
          this.model.unitsize = item.unitsize;
        });

        procure
          .supplierprice({ vendor_id: this.model.vendor_id })
          .then((result) => {
            this.itemprice = result;
            let orderprice;
            this.ordLines.items.forEach((item) => {
              orderprice = this.itemprice.find(
                (ip) => ip.itemno == item.itemno
              );
              if (orderprice) {
                item.unitprice = orderprice.unitprice;
                item.nilainett = orderprice.unitprice * item.quantity;
                item.nilaidue = item.nilaippn + item.nilainett;
                this.calcTotalDtlOrder();
              }
            });
          })
          .catch((err) => {
            console.log("item supplierprice -> ", err);
          });
        toastr.clear;
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    } else {
      this.isLoading = true;
      this.model.orderdate = moment().format("YYYY-MM-DD");
      const [
        a,
        custgroup,
        // detailrequest,
        c,
        custprice,
      ] = await Promise.all([
        procure.customeraktif(),
        customer.group(),
        // procure.detailrequestsmry({tgldelivery:this.model.orderdate}),
        procure.pasalpph(),
        customerprice.listcustprice(),
      ]);
      this.customers = a;
      this.lookupPPH = c;
      this.custprice = custprice;
      this.items = [];
      // this.items = detailrequest;
      if (custgroup) {
        custgroup.map((data) => {
          this.custgroup.push({
            value: data.value,
            text: data.text,
          });
        });
      }

      // let obj;
      // this.items.forEach((item)=> {
      //     obj = {itemno:item.itemno,
      //     partnumber:item.itemcode,
      //     itemname:item.itemname, unitsize:item.unitsize,
      //         unitprice: item.unitcost,
      //         saleprice: item.unitprice,
      //         quantity: item.qtyOrder,
      //         ttlnetto:0,
      //         ttlqty:0,
      //         nilaippn:0,
      //         ttlamtdue:0,
      //         disc:0,
      //         }
      //     this.ordLines.items.push(obj);
      // });
      // this.ordLines.total=detailrequest.length;
      // for (let index = 0; index < detailrequest.length; index++) {
      //     const dt = detailrequest[index];
      //     const findIdx = this.ordLines.items.findIndex(x=>x.itemno==dt.itemno);
      //     if(findIdx>-1){
      //         this.ordLines.items[findIdx][`K${dt.CustCode}`]= dt.qtyOrder
      //     }
      // }
      // this.model.ttlqty = 0;
      // this.ordLines.items.forEach((item)=> {
      //     this.model.ttlqty += item.quantity;
      // });
      this.calcFootLines();
      this.isLoading = false;
    }

    this.$watch("ordLinesObj.quantity", function (newVal) {
      if (newVal == this.ordLinesObj.quantity) {
        setTimeout(() => {
          this.calcAmount();
        }, 100);
      }
    });
    this.$watch("ordLinesObj.unitprice", function (newVal) {
      if (newVal == this.ordLinesObj.unitprice) {
        this.ordLinesObj.nettPrice =
          (parseFloat(newVal) *
            (100 - parseFloat(this.ordLinesObj.disc || 0))) /
          100;
        setTimeout(() => {
          this.calcAmount();
        }, 100);
      }
    });
    this.$watch("ordLinesObj.disc", function (newVal) {
      if (newVal == this.ordLinesObj.disc) {
        this.ordLinesObj.discPrice =
          (parseFloat(this.ordLinesObj.unitprice || 0) * parseFloat(newVal)) /
          100;
        setTimeout(() => {
          this.calcAmount();
        }, 100);
      }
    });

    // this.$watch("ordLinesObj.itemname", function (data) {
    //     console.log("#data: ", data);
    //     console.log("#this: ", this);
    //   if (data == this.ordLinesObj.itemname) {
    //     setTimeout(() => {
    //       this.findItems(data);
    //     }, 100);
    //   }
    // });

    // this.$watch('ordLinesObj.discPrice', function(newVal) {
    //     if (newVal==this.ordLinesObj.discPrice) {
    //         this.ordLinesObj.nettPrice = parseFloat((this.ordLinesObj.unitprice || 0)) -parseFloat(newVal ||0 );
    //         if (this.ordLinesObj.nettPrice>0) {
    //             this.ordLinesObj.printhide=0;
    //         } else {
    //             this.ordLinesObj.printhide=1;
    //         }
    //         setTimeout(() => {
    //             this.calcAmount();
    //         }, 100);
    //     }
    // });
    // this.$watch('model.ttldiskon', function(newVal) {
    //     this.model.ttlnetto=this.model.ttlgross-this.model.ttldiskon;
    //     this.model.ttlamtdue = this.model.ttlnetto+this.model.ttlvat;
    // });
    // this.$watch('model.ttlvat', function(newVal) {
    //     this.model.ttlamtdue = this.model.ttlnetto+this.model.ttlvat;
    // });
  },

  methods: {
    onFiltered(filteredItems) {
      this.ordLines.total = filteredItems.length;
    },

    // itemSuggest: function () {
    //     console.log("#cek1");
    // },

    onSelectLkuCustomer: async function (_selected) {
      console.log("#_selected: ", _selected);
      
      this.model.customer_id = _selected.customer_id;
      this.model.CustCode = _selected.CustCode;
      this.model.CustName = _selected.CustName;
      this.model.customer = `${_selected.CustName} | ${_selected.CustCode}`;
      //this.model.Bill2CustNo = _selected.Bill2CustNo;
      this.lkuCustomerShow = false;
    },

    closeOrdLines: function () {
      const opened = this.ordLines.items.find((r) => r._showDetails == true);
      if (opened) opened._showDetails = false;
    },
    addOrdLines: function () {
      //console.log("#cek addOrdLines...");
      this.isnewproduct = true;
      this.closeOrdLines();
      const linetype = this.ordLines.selected
        ? this.ordLines.selected.linetype
        : 1;
      const obj = { _showDetails: true };
      this.ordLines.selected = obj;
      for (var key in this.ordLinesObj) {
        this.ordLinesObj[key] = "";
      }
      this.ordLinesObj.linetype = linetype;
      this.ordLinesObj.unitsize = "EACH";
      this.ordLinesObj.quantity = 1;
      this.ordLinesObj.kenappn = 1;
      this.ordLinesObj.dppnlain = 100;
      this.ordLinesObj.ppn = 11;
      this.updateDimHdr2Dtl(this.ordLinesObj);
      this.ordLines.items.push(obj);
      this.ordLines.total = this.ordLines.items.length;
      setTimeout(() => {
        const bfore = this.ordLines.page;
        const after = Math.ceil(this.ordLines.total / this.ordLines.limit);
        if (bfore != after) {
          this.ordLines.page = after;
          toastr.info(
            `Move to page ${after} of total  ${ordLines.total} items`,
            "Line/Detail PR",
            10000
          );
        }
      }, 100);
      this.inputLineBerlanjut = 1;
    },
    editOrdLines: function (obj, callback) {
      this.closeOrdLines();
      this.ordLines.selected = obj;
      for (var key in this.ordLinesObj) {
        this.ordLinesObj[key] = "";
      }
      for (var key in obj) {
        this.ordLinesObj[key] = obj[key];
      }
      this.ordLinesObj.saleprice = obj.saleprice || 0;
      this.ordLinesObj.unitsize = obj.unitsize || "EACH";
      this.ordLinesObj.iteminfo =
        obj.partnumber.trim() + " | " + obj.itemname.trim();
      this.ordLinesObj.nilai = obj.quantity * obj.unitprice || 0;
      this.ordLinesObj.dppnlain = obj.dppnlain || 100;

      this.dimension.forEach((dim) => {
        if (obj[dim.value]) {
          this.ordLinesObj[dim.value] = obj[dim.value];
          this.ordLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
          this.ordLinesObj[`${dim.value}Info`] =
            obj[dim.value] + " | " + obj[`${dim.value}Txt`];
        }
      });
      this.tabIndex = 0;
      this.inputLineBerlanjut = 0;
      callback();
    },
    delOrdLines: function (index) {
      if (index > -1) {
        const posisi = (this.ordLines.page - 1) * this.ordLines.limit;
        this.ordLines.items.splice(posisi + index, 1);
      }
      this.ordLines.total = this.ordLines.items.length;
      this.calcTotalDtlOrder();
    },
    updateDimDtl2Hdr: function (dimDtl) {
      var dimHdr = this.model;
      this.dimension.forEach((dim) => {
        if (dimDtl[dim.value] && !dimHdr[dim.value]) {
          dimHdr[dim.value] = dimDtl[dim.value];
          dimHdr[`${dim.value}Txt`] = dimDtl[`${dim.value}Txt`];
          dimHdr[`${dim.value}Info`] = dimDtl[`${dim.value}Info`];
        }
      });
      this.updateDimHdr = !this.updateDimHdr;
    },
    updateDimHdr2Dtl: function (dimDtl) {
      var dimHdr = this.model;
      dimDtl = dimDtl || this.ordLinesObj;
      this.dimension.forEach((dim) => {
        if (dimHdr[dim.value] && !dimDtl[dim.value]) {
          dimDtl[dim.value] = dimHdr[dim.value];
          dimDtl[`${dim.value}Txt`] = dimHdr[`${dim.value}Txt`];
          dimDtl[`${dim.value}Info`] = dimHdr[`${dim.value}Info`];
        }
      });
      this.updateDimDtl = !this.updateDimDtl;
    },
    calcFootLines() {
      let footLines = [];
      let ordLinesItem = this.ordLines.items;
      this.customers.map((data) => {
        const dtfilter = ordLinesItem.filter((x) => x[`K${data.CustCode}`] > 0);
        const sum_ = dtfilter.reduce((ttl = 0, dt) => {
          ttl += dt[`K${data.CustCode}`];
          return ttl;
        }, 0);
        footLines[data.CustCode] = sum_;
      });
      this.footLines = footLines;
    },
    async reloaddata() {
      this.isLoading = true;
      this.model.vendorinfo = "";
      this.model.vendor = "";
      this.model.vendor_id = "";
      this.isLoading = false;
    },
    saveOrdLines: async function (callback) {
      this.ordLinesObj.pasalpph = this.ordLinesObj.pasalpph || "N/A";
      this.ordLinesObj.linetype = this.ordLinesObj.linetype || 1;
      this.isnewproduct=true;
      this.calcPrice(this.ordLinesObj);
      if (this.invalidOrdLines) {
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        //console.log(this.$v.ordLinesObj);
      } else {
        let datadim = this.ordLinesObj;
        datadim.TableName = "po_line";
        try {
          const dimValResult = await dimension.validate(datadim);
          if (dimValResult.success) {
            for (var key in this.ordLinesObj) {
              this.ordLines.selected[key] = this.ordLinesObj[key];
            }
            this.dimension.forEach((dim) => {
              if (datadim[dim.value]) {
                this.ordLines.selected[dim.value] = datadim[dim.value];
                this.ordLines.selected[`${dim.value}Txt`] =
                  datadim[`${dim.value}Txt`];
              }
            });
            this.ordLines.total = this.ordLines.items.length;
            this.model.ttlqty = 0;
            this.ordLines.items.forEach((item) => {
                this.model.ttlqty += parseFloat(item.quantity);
            });
            
            this.updateDimDtl2Hdr(datadim);
            this.calcTotalDtlOrder();
            this.ordLines.selected._showDetails = false;
            if (callback) callback();
            if (this.inputLineBerlanjut == 1) {
              this.addOrdLines();
              this.$v.ordLinesObj.$reset();
            }
            //console.log("#this.ordLines: ", this.ordLines);
          } else {
            var msg = dimValResult.message;
            if (callback) callback(new Error(msg));
            else {
              toastr.error(msg, "ERROR MESSAGE", 10000);
            }
          }
        } catch (error) {
          console.log("error : ", error);
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    save: async function () {
      if (!this.saveEnabled) {
        toastr.error("View mode cannot be Saved");
        return;
      }
      this.saveEnabled = false;
      if (this.invalidModel) {
        console.log("validation : ", this.$v.model);
        console.log("model obj : ", this.model);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
        this.saveEnabled = true;
      } else {
        try {
          this.isLoading = true;
          this.model.TableName = "po_header";
          this.model.pohdrkey = this.model.pohdrkey || "";
          this.model.orderno = this.model.orderno || "";
          const row = {};
          for (var key in this.model) {
            row[key] = this.model[key];
          }
          row.terms = this.model.terms;
          row.orderdate = moment(row.orderdate).format("YYYY-MM-DD");
          row.expectreceipt = row.expectreceipt
            ? moment(row.expectreceipt).format("YYYY-MM-DD")
            : undefined;
          let lineno = 1;
          row.lines = this.ordLines.items.reduce((newArr, item) => {
            if ((item.itemname || "") != "") {
              item.lineno = lineno;
              newArr.push(item);
              lineno += 1;
            }
            return newArr;
          }, []);
          if (row.lines.length > 0) {
            const hasil = await procure.savewholesale(row);
            this.isLoading = false;
            toastr.success(
              `Success, Trx.Number ${hasil.orderno}`,
              "Save Purchase Order",
              10000
            );
            if (this.inputBerlanjut == 0) {
              this.close();
            } else {
              this.saveEnabled = true;
              const tanggal = this.model.orderdate;
              this.model.ttlamtdue = 0;
              this.model.ttlnetto = 0;
              this.model.ttlqty = 0;
              this.model.nilaippn = 0;
              const keys = ["ttlamtdue", "ttlnetto", "ttlqty", "nilaippn"];
              for (var key in this.model) {
                if (keys.indexOf(key) == -1) {
                  this.model[key] = "";
                }
              }
              this.model.orderdate = tanggal;
              this.ordLines.items = [];
              this.ordLines.total = this.ordLines.items.length;
              this.calcTotalDtlOrder();
              this.$v.model.$reset();
            }
          } else {
            toastr.error(
              "Please fill at least 1(one) Order Detail",
              "ERROR MESSAGE"
            );
            this.saveEnabled = true;
            this.isLoading = false;
          }
        } catch (error) {
          this.isLoading = false;
          console.log("error : ", error);
          if (error.sql) {
            toastr.error(error.sql, "ERROR MESSAGE", 10000);
          } else if (error.sqlMessage) {
            toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
          } else if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
          this.saveEnabled = true;
        }
      }
    },

    onSelectLkuItem(lkuData) {
      let lkuSelected = lkuData.selected;
      let dtItems = this.ordLines.items;
      if(lkuSelected.itemno){
        this.isnewproduct = false;
      }
      let toggleIdx = 0;
      for (let index = 0; index < dtItems.length; index++) {
        const dt = dtItems[index];
        if (dt.itemno === lkuSelected.itemno) {
          toggleIdx = 1;
        }
      }
      if (toggleIdx == 0) {
        let unitprice = lkuData.selected.lastprice
          ? lkuData.selected.lastprice
          : 0;
        const findPrice = this.itemprice.find(
          (x) => x.itemno == lkuData.selected.itemno
        );
        if (findPrice) {
          unitprice = findPrice.unitprice;
        }

        //disini findsalesprice
        let saleprice;
        const findSalesPrice = this.custprice.find(
          (x) => x.itemno == lkuData.selected.itemno && x.customer_id == this.model.customer_id
        );

        if (findSalesPrice) {
          saleprice = findSalesPrice.unitprice;
        }

        this.itemList = lkuData.selected;
        this.lkuItemShow = false;
        this.ordLinesObj.itemcode = lkuData.selected.itemcode;
        this.ordLinesObj.partnumber = lkuData.selected.itemcode;
        this.ordLinesObj.itemno = lkuData.selected.itemno;
        this.ordLinesObj.itemname = lkuData.selected.itemname;
        this.ordLinesObj.itemcategory = lkuData.selected.itemcategory;
        // this.ordLinesObj.saleprice=lkuData.selected.unitprice;
        this.ordLinesObj.saleprice=saleprice ? saleprice : 0;

        this.ordLinesObj.iteminfo =
          lkuData.selected.partnumber.trim() +
          " | " +
          lkuData.selected.itemname.trim();
        this.ordLinesObj.quantity = lkuData.selected.qtyOrder
          ? lkuData.selected.qtyOrder
          : 1;
        this.ordLinesObj.tgldelivery = lkuData.selected.tgldelivery;
        this.ordLinesObj.unitprice = unitprice;
        // this.ordLinesObj.nilai = unitprice * lkuData.selected.qtyOrder;
        this.ordLinesObj.nilai = unitprice * this.ordLinesObj.quantity;
        // this.ordLinesObj.nilainett = unitprice * lkuData.selected.qtyOrder;
        this.ordLinesObj.nilainett = unitprice * this.ordLinesObj.quantity;
        this.ordLinesObj.ppn = 11;
        
        // this.calcAmount();
      } else {
        toastr.error("This item request already exists.", "WARNING!");
      }
    },

    calcAmount: function () {
      //console.log("###this.ordLinesObj: ", this.ordLinesObj);
      this.ordLinesObj.nilai =
        parseFloat(this.ordLinesObj.unitprice || 0) *
        parseFloat(this.ordLinesObj.quantity || 0);
      this.ordLinesObj.nettprice =
        parseFloat(this.ordLinesObj.unitprice || 0) *
        parseFloat(this.ordLinesObj.quantity || 0);
      this.ordLinesObj.nilaidisc =
        parseFloat(this.ordLinesObj.discPrice || 0) *
        parseFloat(this.ordLinesObj.quantity || 0);
      this.ordLinesObj.nilainett =
        this.ordLinesObj.nilai - this.ordLinesObj.nilaidisc;

      // console.log('calcAmount : ', this.ordLinesObj);
      // this.calcTaxes();
    },

    findItems: async function (data) {
      try {
        if((this.ordLinesObj.itemno||'')==''){
        if (data) {
          const dataItem = await procure.finditemaktif(data);
          if (dataItem) {
            let unitprice = dataItem.lastprice ? dataItem.lastprice : 0;
            const findPrice = this.itemprice.find(
              (x) => x.itemno == dataItem.itemno
            );
            if (findPrice) {
              unitprice = findPrice.unitprice;
            }
            this.itemList = dataItem;
            this.lkuItemShow = false;
            this.ordLinesObj.itemcode = dataItem.itemcode;
            this.ordLinesObj.partnumber = dataItem.itemcode;
            this.ordLinesObj.itemno = dataItem.itemno;
            this.ordLinesObj.itemname = dataItem.itemname;
            this.ordLinesObj.itemcategory = dataItem.itemcategory;
            this.ordLinesObj.saleprice=dataItem.unitprice;
            this.ordLinesObj.iteminfo =
              dataItem.partnumber.trim() + " | " + dataItem.itemname.trim();
            this.ordLinesObj.quantity = dataItem.qtyOrder ? dataItem.qtyOrder : 1;
            this.ordLinesObj.tgldelivery = dataItem.tgldelivery;
            this.ordLinesObj.unitprice = unitprice;
            this.ordLinesObj.nilai = unitprice * this.ordLinesObj.quantity;
            this.ordLinesObj.nilainett = unitprice * this.ordLinesObj.quantity;
            this.ordLinesObj.ppn = 11;
          } else {
            this.isnewproduct = true;
            let unitprice = dataItem.lastprice ? dataItem.lastprice : 0;
            const findPrice = this.itemprice.find(
              (x) => x.itemno == dataItem.itemno
            );
            if (findPrice) {
              unitprice = findPrice.unitprice;
            }
            this.ordLinesObj.quantity = dataItem.qtyOrder ? dataItem.qtyOrder : 1;
            this.ordLinesObj.unitprice = unitprice;
            this.ordLinesObj.nilai = unitprice * this.ordLinesObj.quantity;
            this.ordLinesObj.nilainett = unitprice * this.ordLinesObj.quantity;
            this.ordLinesObj.ppn = 11;
            this.ordLinesObj.iteminfo =
              this.ordLinesObj.partnumber ||
              "".trim() + " | " + this.ordLinesObj.itemname ||
              "".trim();
          }
        }
        }
       
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    },

    addnewitem:function(data){
      this.lkuItemShow = false;
      this.ordLinesObj.itemname=data;
    },

    onSelectLkuVendor: async function (_selected) {
      try {
        this.items = [];
        this.ordLines.items = [];
        this.model.vendorinfo =
          _selected.vendor_code.trim() + " | " + _selected.vendor_name.trim();
        this.model.vendor = _selected.vendor_code;
        this.model.vendor_id = _selected.vendor_id;
        this.lkuVendorShow = false;
      } catch (error) {
        console.log("error : ", error);
        toastr.error(JSON.stringify(error), "ERROR MESSAGE");
      }
    },

    generateQtyCustomer: function () {
      toastr.info("generate Customer Qty Order randomly");
      let obj;
      let orderprice;
      this.ordLines.items.forEach((item) => {
        orderprice = this.itemprice.find((ip) => (ip.itemno = item.itemno));
        if (orderprice) {
          item.unitprice = orderprice.unitprice;
        }
        this.customers.forEach((kol) => {
          item[`K${kol.CustCode}`] = Math.floor(Math.random() * 11);
          item.quantity += item[`K${kol.CustCode}`];
        });

        this.calcPrice(item);
      });
      this.calcTotalDtlOrder();
    },
    calcTotQty: function (record) {
      setTimeout(() => {
        record.quantity = 0;
        this.customers.forEach((kol) => {
          record.quantity += parseFloat(record[`K${kol.CustCode}`] || 0);
        });
        this.calcPrice(record);
        this.calcTotalDtlOrder();
      }, 100);
    },
    calcTotalDtlOrder: function () {
      this.calcVAT = this.calcVAT || 1;
      let nilaippn = 0;
      let ttlnetto = 0;
      let ttlqty = 0;
      let ttlamtdue = 0;
      this.ordLines.items.forEach(function (trx) {
        if (trx.itemname) {
          ttlnetto += trx.nilainett || 0;
          ttlqty += parseFloat(trx.quantity) || 0;
          nilaippn += trx.nilaippn || 0;
          ttlamtdue = ttlnetto + (nilaippn || 0);
        }
      });
      this.model.ttlnetto = ttlnetto;
      this.model.ttlqty = ttlqty;
      if (this.calcVAT == 1) {
        this.model.nilaippn = nilaippn;
      }
      this.model.ttlamtdue = ttlamtdue;
    },
    calcAmountDue: function () {
      this.model.ttlamtdue =
        parseFloat(this.model.ttlnetto || 0) +
        parseFloat(this.model.nilaippn || 0);
    },
    // calcTaxes : function(record) {
    //     console.log("#record: ", record);
    //     record.nilainett = parseFloat(record.nilai) - parseFloat(record.nilaidisc || 0);
    //     record.dpp = parseFloat(record.nilai) * parseFloat(record.dppnlain) / 100;
    //     if (record.kenappn == 1) {
    //         record.ppn = record.ppn || 11;
    //     } else {
    //         record.dpp = 0;
    //         record.ppn = 0;
    //     }
    //     record.nilaippn = parseFloat(record.ppn) / 100 * record.dpp;
    //     record.nilaidue = record.nilainett + record.nilaippn;
    // },
    calcTaxes: function (record) {
      //console.log("#record: ", record);
      // this.ordLinesObj.ppn = this.ordLinesObj.ppn || 11;

      record.nilainett =
        parseFloat(record.nilai) - parseFloat(record.nilaidisc || 0);
      record.dpp =
        (parseFloat(record.nilai) * parseFloat(record.dppnlain)) / 100;
      if (record.kenappn == 1) {
        record.ppn = record.ppn || 11;
        // this.ordLinesObj.ppn = this.ordLinesObj.ppn || 11;
      } else {
        record.dpp = 0;
        record.ppn = 0;
      }
      record.nilaippn = (parseFloat(record.ppn) / 100) * record.dpp;
      record.nilaidue = record.nilainett + record.nilaippn;

      // this.ordLinesObj.dpp = parseFloat(this.ordLinesObj.nilainett  || 0);
      // if (this.ordLinesObj.kenappn == 0) {
      //     this.model.grossup = 0;
      //     this.ordLinesObj.ppn = 11;
      // } else {
      //     this.ordLinesObj.dpp = 0;
      //     this.ordLinesObj.ppn = 0;
      // }
      // console.log("#this.ordLinesObj: ", this.ordLinesObj);
      // this.ordLinesObj.nilaippn = 0.11 * this.ordLinesObj.dpp;
      // this.ordLinesObj.nilaidue = this.ordLinesObj.nilainett + this.ordLinesObj.nilaippn;
      this.$forceUpdate();
    },

    calcPrice: function (record) {
      //console.log("#record calcPrice: ", record);
      record.nilai = parseFloat(record.quantity) * parseFloat(record.unitprice);
      record.disc = record.disc ? record.disc : 0;
      if (record.disc > 0) {
        record.nilaidisc = (record.disc * record.nilai) / 100.0;
      }
      this.calcTaxes(record);
    },
    calcPriceDelay: function (record) {
      const this_ = this;
      setTimeout(() => {
        record.nilai = parseFloat(record.quantity) * parseFloat(record.unitprice);
        if (record.disc > 0) {
          record.nilaidisc = (record.disc * record.nilai) / 100.0;
        }
        this_.calcTotalDtlOrder();
      }, 100);
    },
    async tanggalBerubah() {
      try {
        this.isLoading = true;
        this.model.vendor_id = "";
        this.model.vendorinfo = "";
        this.model.vendor = "";
        this.model.customer = "";
        this.model.customer_id = "";
        this.ordLines.items = [];
        this.tahun = moment(this.model.orderdate).format("YYYY");
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.sql) {
          toastr.error(error.sql, "ERROR MESSAGE", 10000);
        } else if (error.sqlMessage) {
          toastr.error(error.sqlMessage, "ERROR MESSAGE", 10000);
        } else if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
        this.saveEnabled = true;
      }
    },

    close() {
      //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      if (
        this.$store.state.prevRoute.name &&
        this.$store.state.prevRoute.name !== "bakery.orderfrm"
      ) {
        router.push({ name: this.$store.state.prevRoute.name });
      } else {
        // router.push({name:'payable.apinv'});
        router.push("home");
      }
    },
  },
};
</script>
